<template>
  <ModalBase :show-modal="true" @close-modal="close" :auto-h="true" :narrow="true" :overlay-scrollb="false" >
    <template v-slot:titlebar>
      <TitleBar variant-class="title-modal title-modal--simple">
        <template v-slot:title>
          <span>{{ $gettext('Add an online payment link') }}</span>
        </template>
      </TitleBar>
    </template>
    <template v-slot:maincontent>
      <b-row>
        <b-col cols="4">
          <AnimationItem class="anim-company" :animation="{ animationData: paymentLinkAnimation.default }" :key="'anim_success'" />
        </b-col>
        <b-col>
          <p v-if="status === 'failed'" v-translate>
            There was an error connecting to Rootline. Please try submitting the application form again or contact our support team.
          </p>
          <p v-if="status === 'disconnected'" v-translate>
            Your Rootline account was disconnected. Please try submitting the application form again or contact our support team.
          </p>
          <p v-if="status === 'started'" v-translate>
            You already started your account setup process for your payment account. If you have not finished your application, please finish this by clicking on the link below. Otherwise, please contact support@getgekko.com to inquire what the status is of your account.
          </p>
          <div v-if="status === 'not-found'">
            <p v-translate>A payment link with your invoice will on average let your customers pay 3 times faster. You can add a link by setting up a free account with our partner Rootline.</p>
            <p v-translate>You just have to setup a payment account with our partner Rootline.</p>
            <p class="info-text" v-translate>Fees apply only per successfull transaction. A digital photocopy of your ID is required for setup.</p>
          </div>
        </b-col>
      </b-row>
    </template>
    <template v-slot:actions>
      <div style="text-align: right;">
          <GekkoButton
            @click="connectRootline"
            :text="$gettext('Get started')"
            icon="fa-solid fa-plug"
          />
      </div>
    </template>
  </ModalBase>
</template>

<script>
import TitleBar from "@/components/TitleBar";
import GekkoButton from "@/components/GekkoButton";
import ModalBase from "@/components/base_components/ModalBase";
import IdealPaymentService from '@/store/services/idealpayment.service.js';
import * as paymentLinkAnimation from '@/css/animations/payment-link.json';
import AnimationItem from '@/components/dashboard/ui/AnimationItem.vue';

export default {
  name: 'RootlineErrorModal',
  components: {
    TitleBar,
    GekkoButton,
    ModalBase,
    AnimationItem
  },
  props: {
    status: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      paymentLinkAnimation: paymentLinkAnimation
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    connectRootline() {
      let data = {company_profile: window.company_id}
      IdealPaymentService.rootlineRequestConnection(data).then((response) => {
          window.location.href = response.data.href
      }).catch((error) => {
          if (error.status === 409) {
              this.$store.commit('setAlert', {
                  title: this.$gettext("Already connected"),
                  text: this.$gettext("You are already connected to rootline!"),
                  variant: "danger",
                  duration: 4
              })
          } else {
              this.$store.commit('setAlert', {
                  title: this.$gettext("Something went wrong when trying to connect!"),
                  text: this.$gettext("The connection to Rootline was unsuccessful. Please try again later."),
                  variant: "danger",
                  duration: 4
              })
          }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.info-text {
  font-style: italic;
  color: $colorTextSemi;
  font-size: 14px;
  margin-bottom: 1rem;
}
</style>